<div class="modal-header">
    <h2 class="modal-title">Bulk Update</h2>
</div>
<div class="modal-body" (keyup.esc)="cancel()">
    <dx-form validationGroup="mainValidationGroup" [labelLocation]="'left'">
        @if(auth.hasRole('BuildDetail:CanUpdateShipDue')) {
        <dxi-item itemType="group" class="align-items-center" colCount="3" [hidden]="!auth.hasRole('BuildDetail:CanUpdateShipDue')">
            <dxi-item class="d-flex" [label]="{ text: 'Ship Due Date' }" [colSpan]="2">
                <div *dxTemplate class="d-flex">
                    <dx-date-box class="flex-fill" [(value)]="dueDateValue"></dx-date-box>
                </div>
                <dxi-validation-rule type="custom" message="Due Date, Status, or Delivery required." [validationCallback]="inputRequired" reevaluate="true"></dxi-validation-rule>
            </dxi-item>
            <dxi-item class="flex-fill">
                <div *dxTemplate class="d-flex">
                    <button class="btn btn-sm btn-success ms-1" (click)="setDueDate()">Today+Lead</button>
                </div>
            </dxi-item>
        </dxi-item>
        } 
        
        @if(auth.hasRole('BuildDetail:CanUpdateBuildDue')) {
        <dxi-item itemType="group" class="align-items-center" colCount="3">
            <dxi-item class="d-flex" [label]="{ text: 'Build Due Date' }" [colSpan]="2" [hidden]="!auth.hasRole('BuildDetail:CanUpdateBuildDue')">
                <div *dxTemplate class="d-flex">
                    <dx-date-box class="flex-fill" [(value)]="buildDueDateValue"></dx-date-box>
                </div>
                <dxi-validation-rule type="custom" message="Due Date, Status, or Delivery required." [validationCallback]="inputRequired" reevaluate="true"></dxi-validation-rule>
            </dxi-item>
            <dxi-item class="flex-fill">
                <div *dxTemplate class="d-flex">
                    <button class="btn btn-sm btn-success ms-1" (click)="setBuildDueDate()">Today+Lead</button>
                </div>
            </dxi-item>
        </dxi-item>
        }

        <dxi-item [label]="{ text: 'Status', labelLocation: 'top' }">
            <div *dxTemplate>
                <dx-select-box
                    #inputComponent
                    [(value)]="statusIdValue"
                    [items]="statusOptions"
                    [valueExpr]="'id'"
                    [displayExpr]="'name'"
                    searchEnabled="true"
                    searchMode="startswith"
                >
                </dx-select-box>
            </div>
            <dxi-validation-rule type="custom" message="Due Date, Status, or Delivery required." [validationCallback]="inputRequired" reevaluate="true"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Delivery', labelLocation: 'top' }">
            <div *dxTemplate>
                <dx-select-box #inputComponent [(value)]="deliveryValue" [items]="deliveryOptions" displayExpr="name" searchEnabled="true" searchMode="startswith"> </dx-select-box>
            </div>
            <dxi-validation-rule type="custom" message="Due Date, Status, or Delivery required." [validationCallback]="inputRequired" reevaluate="true"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Notes', labelLocation: 'top' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="noteValue" [height]="150"> </dx-text-area>
            </div>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()" [disabled]="processing">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
